<template>
    <div class="main-service">
        <el-row>
            <el-button @click="deployJava()">部署后端接口</el-button>
            <el-button @click="deployHtml()">部署后端页面</el-button>
            <el-button @click="restartTomcat()">重启服务容器</el-button>
        </el-row>
    </div>
</template>

<script>
import {deployJava,deployHtml,restartTomcat} from '@/api/service.js'

export default {
    name: 'Service',
    methods: {
        deployJava(){
            deployJava().then(()=>{
                
            })
        },
        deployHtml(){
            deployHtml().then(()=>{
                location.reload()
            })
        },
        restartTomcat(){
            restartTomcat().then(()=>{
                
            })
        },
    }
}
</script>

<style lang="scss">
    .main-service{
        .el-dialog .el-row{
            margin-bottom: 15px;
        }
        .el-button{
            margin-right: 15px;
        }
    }
</style>